import React, { useEffect, useState, useRef } from 'react';
import { dividerClasses, Tooltip } from '@mui/material';
import FUCollapse from './components/Collapse';
import { FaAngleDown } from 'react-icons/fa6';
import { Divider, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import qs from 'qs';
import { fetchAccountInformation, fetchAccountBill, fetchAccountPayment, fetchBillList, download_pdf, fetchUsageList } from "./api/api";
import { enqueueSnackbar } from "notistack";
import moment from 'moment';
import { FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import { FaSpinner } from 'react-icons/fa';
import { Charts } from './components/charts'
import { DatePicker, Select } from 'antd';
import dayjs from "dayjs";


const { Option } = Select;
const DashedDivider = styled(Divider)(({ theme }) => ({
  borderStyle: 'dashed',
  borderColor: theme.palette.grey[700]
}));
interface MonthlyData {
  start_time: string;
  end_time: string;
  providedCost: number;
  value: string;
}

interface ChartData {
  name: string;
  value: number;
  label: string;
}

// Helper to format dates as "MMM YYYY"
const formatDate = (dateStr: string, includeYear: boolean = false): string => {
  const date = new Date(dateStr);
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    year: includeYear ? 'numeric' : undefined
  };
  return date.toLocaleDateString('en-US', options);
};

// Process the data for the chart and dropdown options
const processData = (data: MonthlyData[]): { chartData: ChartData[], dropdownOptions: string[] } => {
  // Preprocess the data to ensure all entries have a valid end_time
  const processedData = data.map((item) => {
    if (!item.end_time) {
      // If end_time is null, use the month of start_time as the reference
      return { ...item, end_time: item.start_time };
    }
    return item;
  });

  // Sort by end_time in descending order (latest first)
  const sortedData = processedData.sort((a, b) => new Date(b.end_time).getTime() - new Date(a.end_time).getTime());
  const last24Data = sortedData.slice(0, 24); // Take the most recent 24 months of data
  const allDates: Date[] = [];

  // Build an array of continuous 24 months of dates
  let currentDate = new Date(sortedData[0].end_time); // Start from the latest end_time
  for (let i = 0; i < 24; i++) {
    allDates.push(new Date(currentDate));
    currentDate.setMonth(currentDate.getMonth() - 1); // Step back one month at a time
  }

  // Build chart data, filling in missing months with zero values
  const chartData: ChartData[] = allDates.map((date) => {
    const dataEntry = last24Data.find((item) => {
      const itemDate = new Date(item.end_time);
      return itemDate.getFullYear() === date.getFullYear() && itemDate.getMonth() === date.getMonth();
    });

    const value = dataEntry ? parseFloat(Number(dataEntry.value.replace(/[^\d.-]/g, '')).toFixed(2)) : 0;
    const name = formatDate(date.toISOString(), true);
    const label = dayjs(date).format('MM/YYYY');

    return {
      name: name, // Optionally use label as name
      value,
      label,
    };
  });

  // Reverse chartData to order it from earliest to latest
  chartData.reverse();

  // Create dropdown options for each 12-month period
  const dropdownOptions: string[] = [];
  for (let i = 0; i < 2; i++) { // Create only two 12-month periods
    const start = allDates[i * 12];
    const end = allDates[i * 12 + 11];
    dropdownOptions.push(`${formatDate(end.toISOString(), true)} to ${formatDate(start.toISOString(), true)}`);
  }

  return { chartData, dropdownOptions };
};

// Updated filterChartData to use reversed chartData
const filterChartData = (chartData: ChartData[], selectedRange: string): ChartData[] => {
  const [startLabel, endLabel] = selectedRange.split(' to ');

  const startIndex = chartData.findIndex((data) => data.name === startLabel);
  const endIndex = chartData.findIndex((data) => data.name === endLabel);

  if (startIndex !== -1 && endIndex !== -1 && startIndex <= endIndex) {
    return chartData.slice(startIndex, endIndex + 1);
  }

  return [];
};


const Detail = () => {
  // dayjs.extend(utc);
  const navigate = useNavigate();
  const location = useLocation();
  const { type, zipcode, provider } = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [DetailList, setDetailList] = useState<any[]>([]);
  const [chartData, setChartData] = useState<any>([]);
  const [information, setInformation] = useState<any>(undefined);
  const [openAccordions, setOpenAccordions] = useState<number[]>([0, 1]);
  const [isFetching, setIsFetching] = useState(false);
  const [AccountBill, setAccountBill] = useState<any>(undefined);
  const [AccountPayment, setAccountPayment] = useState<any>(undefined);
  const [userToken, setUserToken] = useState<string>('');
  const [flagList, setFlagList] = useState<any[]>([]);
  const [openTooltipIndex, setOpenTooltipIndex] = useState<any>(null);
  const [showAll, setShowAll] = useState(false);
  const [usageError, setUsageError] = useState<boolean>(false);
  const [chartDataMonth, setChartDataMonth] = useState<any[]>([]);
  const [optionMonth, setOptionMonth] = useState<any[]>([]);
  const [selectedRangeMonth, setSelectedRangeMonth] = useState<any>('');
  const [month, setMonth] = useState<any>(null);
  const [daySelect, setDaySelect] = useState<any>(null);
  const [disabledDates, setDisabledDates] = useState<any>([]);
  const [daily, setDaily] = useState<any[]>([]);
  const [filteredDaily, setFilteredDaily] = useState<any[]>([]);
  const [availableDates, setAvailableDates] = useState<any>([]);
  const [filteredHoursData, setFilteredHoursData] = useState<any[]>([]);
  const [HoursData, setHoursData] = useState<any[]>([]);

  const handleToggleShow = () => {
    setShowAll(prev => !prev);
  };

  const handleTooltipOpen = (index: string) => {
    setOpenTooltipIndex(index);
  };

  const handleTooltipClose = () => {
    setOpenTooltipIndex(null);
  };


  const isInitialized = useRef(false);
  const [billsImgList, setbillsImgList] = useState<any[]>([]);
  const [usageList, setusageList] = useState<any>(null);
  const [active, setActive] = useState('year');

  const handleAccordionToggle = (index: number) => () => {
    setOpenAccordions((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [])

  useEffect(() => {
    const dataJson = localStorage.getItem('ez_switch');
    setDetailList([]);
    if (dataJson) {
      const data = JSON.parse(dataJson);

      let newArr = [];
      let loginItem = [];
      if (data) {
        if (data.userInfo) {
          loginItem.push({ label: 'Energy Provider', value: data.userInfo.utility_name });
        }
        if (data.userInfo) {
          loginItem.push({ label: 'Login Username', value: data.userInfo.username });
        }
        if (loginItem.length > 0) {
          newArr.push({ title: 'Account Login', data: loginItem });
        }
      }
      let verificationItem = [];
      verificationItem.push({ label: 'Does the MyAccount have two - step verification', value: data.is_two_step_verification != 0 ? 'YES' : 'NO', valueTooltip: data.is_two_step_verification != 0 ? `The MyAccount of this ${data.userInfo.utility_name} supports manually turning off two-step verification. The "Turn Off" button is usually located in the account settings options for closing.` : `The MyAccount of this ${data.userInfo.utility_name} does not support turning off two-step verification for the time being.` });
      if (data && data.method) {
        verificationItem.push({ label: 'Verification Method', value: data.method });
      }
      if (verificationItem.length > 0) {
        newArr.push({ title: 'Two-step Verification', data: verificationItem });
      }
      if (type === 'all') {
        newArr.push({ title: 'Account Payment', data: [] });
        newArr.push({ title: 'Account Information', data: [] });
        newArr.push({ title: 'Account Bill', data: [] });
        newArr.push({ title: 'Usage', data: [] });
      }
      else if (type === 'information') {
        newArr.push({ title: 'Account Information', data: [] });
      }
      else if (type === 'bill') {
        newArr.push({ title: 'Account Bill', data: [] });
      }
      else if (type === 'payment') {
        newArr.push({ title: 'Account Payment', data: [] });
      }
      else if (type === 'usage') {
        newArr.push({ title: 'Usage', data: [] });
      }
      setDetailList(newArr);
    } else {
      navigate('/demo');
    }
  }, []);

  useEffect(() => {
    const openIndices = DetailList
      .map((item, idx) => (item.data.length > 0 ? idx : -1))
      .filter(index => index !== -1);

    setOpenAccordions(openIndices);
  }, [DetailList]);

  useEffect(() => {
    if (!type || isFetching) return;

    if (!isInitialized.current) {
      isInitialized.current = true;

      const dataJson = localStorage.getItem('ez_switch');


      if (dataJson) {
        const data = JSON.parse(dataJson);
        setUserToken(data.token)
        let params = { token: data.token };

        setIsFetching(true);
        const typeToInterfacesMap: { [key: string]: string[] } = {
          'all': ['information', 'bill', 'payment', 'pnglist', 'usage'],
          'information': ['information'],
          'bill': ['bill', 'pnglist'],
          'payment': ['payment'],
          'usage': ['usage'],
        };
        const validType = Array.isArray(type) ? type[0] : (typeof type === 'string' ? type : '');
        const failedInterfaces = typeToInterfacesMap[validType.toString()] || [];
        getDetailHandle(params, { information: 0, bill: 0, payment: 0, pnglist: 0, usage: 0, }, failedInterfaces)
      }
    }
  }, [type]);


  const getDetailHandle = (
    params: any,
    failedCounts: { [key: string]: number } = { information: 0, bill: 0, payment: 0, pnglist: 0 },
    failedInterfaces: string[] = []
  ) => {
    let flag = false;
    let flagList: string[] = []

    const fetchAccountDetails = (retryInterfaces: string[], currentFailedCounts: { [key: string]: number }) => {
      const requests = [];

      if (retryInterfaces.includes('information')) {
        requests.push(
          fetchAccountInformation(params).then((res: any) => {
            if (res.status === 1) {
              if (res.response.code === "500") {
                flagList.push('information');
                currentFailedCounts['information']++;
              } else {
                setInformation(res.response);
                currentFailedCounts['information'] = 0;
              }
            }
            else if (res.status === -4 || res.status === -3) {
              flag = true;
            }
            else {
              flagList.push('information');
              currentFailedCounts['information']++;
            }
          }).catch(() => {
            flagList.push('information');
            currentFailedCounts['information']++;
          })
        );
      }

      if (retryInterfaces.includes('bill')) {
        requests.push(
          fetchAccountBill(params).then((res: any) => {
            if (res.status === 1) {
              if (res.response.code === "500") {
                flagList.push('bill');
                currentFailedCounts['bill']++;
              } else {
                setAccountBill(res.response);
                currentFailedCounts['bill'] = 0;
              }
            }
            else if (res.status === -4 || res.status === -3) {
              flag = true;
            }
            else {
              flagList.push('bill');
              currentFailedCounts['bill']++;
            }
          }).catch(() => {
            flagList.push('bill');
            currentFailedCounts['bill']++;
          })
        );
      }

      if (retryInterfaces.includes('payment')) {
        requests.push(
          fetchAccountPayment(params).then((res: any) => {
            if (res.status === 1) {
              if (res.response.code === "500") {
                flagList.push('payment');
                currentFailedCounts['payment']++;
              } else {
                setAccountPayment(res.response);
                currentFailedCounts['payment'] = 0;
              }
            }
            else if (res.status === -4 || res.status === -3) {
              flag = true;
            }
            else {
              flagList.push('payment');
              currentFailedCounts['payment']++;
            }
          }).catch(() => {
            flagList.push('payment');
            currentFailedCounts['payment']++;
          })
        );
      }

      if (retryInterfaces.includes('pnglist')) {
        requests.push(
          fetchBillList(params).then((res: any) => {
            if (res.status === 1) {
              if (res.response.code === "500") {
                flagList.push('pnglist');
                currentFailedCounts['pnglist']++;
              } else {
                setbillsImgList(res.response);
                currentFailedCounts['pnglist'] = 0;
              }
            }
            else if (res.status === -4 || res.status === -3) {
              flag = true;
            }
            else {
              flagList.push('pnglist');
              currentFailedCounts['pnglist']++;
            }
          }).catch(() => {
            flagList.push('pnglist');
            currentFailedCounts['pnglist']++;
          })
        );
      }

      if (retryInterfaces.includes('usage')) {
        requests.push(
          fetchUsageList(params).then((res: any) => {
            if (res.status === 1) {
              if (res.response.code === "500") {
                flagList.push('usage');
                currentFailedCounts['usage']++;
              } else {
                if (res.response.monthly.length === 0 && res.response.daily.length === 0 && res.response.hourly_view.length === 0) {
                  setUsageError(true)
                  return
                }
                else {
                  setusageList(res.response);
                  if (res.response.monthly && res.response.monthly.length > 0) {
                    const { chartData, dropdownOptions } = processData(res.response.monthly);
                    setOptionMonth(dropdownOptions)
                    setSelectedRangeMonth(dropdownOptions[0])
                    setChartDataMonth(chartData)
                  }
                  if (res.response.daily && res.response.daily.length > 0) {
                    processDisableData(res.response.daily);
                    setDaily(res.response.daily)
                  }
                  if (res.response.hourly_view && res.response.hourly_view.length > 0) {
                    const dates = res.response.hourly_view.map((item: any) =>
                      dayjs(item.end_time || item.start_time).format('YYYY-MM-DD')
                    );
                    const uniqueDatesObj: { [key: string]: boolean } = {};
                    dates.forEach((date: any) => {
                      uniqueDatesObj[date] = true;
                    });

                    const uniqueDates = Object.keys(uniqueDatesObj);
                    const latestDate = uniqueDates.reduce((maxDate, currentDate) => {
                      return dayjs(currentDate).isAfter(dayjs(maxDate)) ? currentDate : maxDate;
                    }, uniqueDates[0]);

                    setDaySelect(dayjs(latestDate));

                    const hoursData = filterDataBySelectedDate(res.response.hourly_view, dayjs(latestDate).format('YYYY-MM-DD'));
                    setHoursData(res.response.hourly_view);
                    setFilteredHoursData(hoursData);
                    setAvailableDates(uniqueDates);
                  }
                }
                currentFailedCounts['usage'] = 0;
              }
            }
            else if (res.status === -4 || res.status === -3) {
              flag = true;
            }
            else {
              flagList.push('usage');
              currentFailedCounts['usage']++;
            }
          }).catch(() => {
            flagList.push('usage');
            currentFailedCounts['usage']++;
          })
        );
      }

      return Promise.all(requests);
    };

    const retryInterfaces = failedInterfaces.length > 0 ? failedInterfaces : ['information', 'bill', 'payment', 'pnglist', 'usage'];

    fetchAccountDetails(retryInterfaces, failedCounts).finally(() => {
      if (flag) {
        enqueueSnackbar(
          "The data retrieved from the website has expired. Please return to the login page and resubmit.",
          { variant: "error" }
        );
        navigate(`/demo?zip=${zipcode}&provider=${provider}`);
        setIsFetching(false);
      }

      const failedThreeTimes = Object.keys(failedCounts).some((key) => failedCounts[key] >= 3);

      if (failedThreeTimes) {
        // enqueueSnackbar(
        //   "Due to issues with the other website, the account data could not be retrieved. Please resubmit to try again.",
        //   { variant: "error" }
        // );
        // navigate(`/demo?zip=${zipcode}&provider=${provider}`);
        setIsFetching(false);
        setFlagList(flagList)
        return
      }
      else if (flagList.length > 0) {
        // const failedOnce = flagList.some((key) => failedCounts[key] === 1);
        // if (failedOnce) {
        //   enqueueSnackbar(
        //     "The data query has failed. We are reloading the data for you, please be patient.",
        //     { variant: "error" }
        //   );
        // }
        getDetailHandle(params, failedCounts, flagList)
        return
      }
      setIsFetching(false);

    });
  };
  useEffect(() => {
    setTimeout(() => {

      errorList(flagList)
    }, 200)
  }, [flagList])

  const filterDataBySelectedDate = (data: any[], selectedDate: string) => {
    return data.filter((item: any) => {
      const time = item.start_time ? item.start_time : item.end_time;
      const formattedDate = dayjs(time).format('YYYY-MM-DD');
      return formattedDate === selectedDate;
    });
  };

  const filterDailyData = (selectedMonth: dayjs.Dayjs, dailyData: any[]) => {
    const filtered = dailyData.filter((item: any) => {
      const startTime = item.start_time ? dayjs(item.start_time) : null;
      const endTime = item.end_time ? dayjs(item.end_time) : null;

      const monthToCheck = startTime || endTime;
      return monthToCheck && monthToCheck.format("YYYY-MM") === selectedMonth.format("YYYY-MM");
    });

    setFilteredDaily(filtered);
  };

  const processDisableData = (data: any) => {
    let availableMonths: string[] = [];

    data.forEach((item: any) => {
      const startTime = item.start_time ? dayjs(item.start_time) : null;
      const endTime = item.end_time ? dayjs(item.end_time) : null;

      let month = null;

      if (startTime && startTime.isValid()) {
        month = startTime.format('YYYY-MM');
      } else if (endTime && endTime.isValid()) {
        month = endTime.format('YYYY-MM');
      }

      if (month && !availableMonths.includes(month)) {
        availableMonths.push(month);
      }
    });

    availableMonths.sort((a, b) => dayjs(b).isBefore(dayjs(a)) ? -1 : 1);

    if (availableMonths.length > 0) {
      setMonth(dayjs(availableMonths[0]));
      filterDailyData(dayjs(availableMonths[0], "YYYY-MM"), data);
    }

    setDisabledDates(availableMonths);

    return availableMonths;
  };


  const addErrorIfExists = (title: string) => {
    let newArr = [...DetailList];
    const existingItem = newArr.find(item => item.title === title);
    if (existingItem) {
      if (existingItem.data.length === 0) {
        existingItem.error = true;
      }
    }
  };
  useEffect(() => {
    if (usageError) {
      errorList(['usage'])

    }
  }, [usageError])

  const errorList = (flagList: any) => {
    if (flagList.length === 0) {
      return
    }

    let newArr = [...DetailList];

    const isTitleExists = (title: string) => {
      return newArr.some((item) => item.title === title);
    };

    if (flagList.includes('information')) {
      if (!isTitleExists('Account Information')) {
        newArr.push({ title: 'Account Information', data: [], error: true });
      } else {
        addErrorIfExists('Account Information');
      }
    }

    if (flagList.includes('bill')) {
      if (!isTitleExists('Account Bill')) {
        newArr.push({ title: 'Account Bill', data: [], error: true });
      } else {
        addErrorIfExists('Account Bill');
      }
    }

    if (flagList.includes('payment')) {
      if (!isTitleExists('Account Payment')) {
        newArr.push({ title: 'Account Payment', data: [], error: true });
      } else {
        addErrorIfExists('Account Payment');
      }
    }

    if (flagList.includes('pnglist')) {
      if (!isTitleExists('Account Bill')) {
        newArr.push({ title: 'Account Bill', data: [], error: true });
      } else {
        addErrorIfExists('Account Bill');
      }
    }

    if (flagList.includes('usage')) {
      if (!isTitleExists('Usage')) {
        newArr.push({ title: 'Usage', data: [], error: true });
      } else {
        addErrorIfExists('Usage');
      }
    }

    setDetailList(newArr);
  }


  const updateDetailList = (key: string, data: any, ispng: boolean = false) => {
    let newArr = [...DetailList];
    let itemArr = [];

    switch (key) {
      case 'Account Information':
        if (data.name) itemArr.push({ label: 'User Name', value: data.name });
        if (data.address) itemArr.push({ label: 'Address', value: data.address });
        if (data.city || data.state || data.zip_code) {
          const fields = [
            { key: 'city', label: 'City' },
            { key: 'state', label: 'State' },
            { key: 'zip_code', label: 'Zipcode' },
          ];
        
          const validFields = fields.filter(field => data[field.key]);
        
          if (validFields.length > 0) {
            const label = validFields.map(field => field.label).join('/');
            const value = validFields.map(field => data[field.key]).join(' ');
            itemArr.push({
              label,
              value,
            });
          }
        }
        if (data.account_number) itemArr.push({ label: 'Account Number', value: data.account_number });
        if (data.esi_id) itemArr.push({ label: 'ESIID', value: data.esi_id });
        if (data.plan_name) itemArr.push({ label: 'Plan Name', value: data.plan_name });
        break;

      case 'Account Bill':
        if (ispng) {
          if (data) itemArr.push({ label: 'Account Bill History', tooltip: 'The bill history list shows data from up to 1 year prior to the current month.', value: '', imgList: data, });
        } else {
          if (data.ratio) itemArr.push({ label: 'The Total Number of bill in Past Year(12 Months)', value: data.ratio, tooltip: 'The actual paid bill for the account / The actual generated bill for the account' });
          if (data.last_bill_date) itemArr.push({ label: 'Last Bill Date', value: moment(data.last_bill_date).format('MM/DD/YYYY') });
          if (data.last_bill) itemArr.push({ label: 'Amount Due', value: `$${Number(data.last_bill).toFixed(2)}` });
        }
        break;

      case 'Account Payment':
        if (data.payments != null && data.bills != null) itemArr.push({ label: 'Number of bills used in the last 1 year (12 months)', value: data.payments + "/" + data.bills, tooltip: 'The actual account bill / monthly bills for one year' });
        if (data.last_payment_date) itemArr.push({ label: 'Last Payment Date', value: data.last_payment_date });
        if (data.last_payment) itemArr.push({ label: 'Amount Paid', value: `$${Number(data.last_payment).toFixed(2)}` });
        break;

      case 'Usage':
        if (data) itemArr.push({ label: 'Usage total', usage: data });
        break

      default:
        break;
    }
    const existingIndex = newArr.findIndex(item => item.title === key);
    if (itemArr.length > 0) {

      if (existingIndex > -1) {
        newArr[existingIndex].data = [...newArr[existingIndex].data, ...itemArr];
        if (!ispng && key === 'Account Bill') {
          const accountBillHistoryItem = newArr[existingIndex].data.find((item: any) => item.label === 'Account Bill History');
          if (accountBillHistoryItem) {
            newArr[existingIndex].data = newArr[existingIndex].data.filter((item: any) => item.label !== 'Account Bill History');
            newArr[existingIndex].data.push(accountBillHistoryItem);
          }
        }
      } else {
        newArr.push({ title: key, data: itemArr });
      }
    } else {

      if (existingIndex > -1) {
        newArr[existingIndex].error = true;
      }
    }
    const emptyIndex = newArr.findIndex(item => item.data.length === 0);

    if (emptyIndex > -1 && existingIndex > -1 && existingIndex > emptyIndex) {
      const emptyItem = newArr[emptyIndex];
      const latestItem = newArr[existingIndex];

      newArr[emptyIndex] = latestItem;
      newArr[existingIndex] = emptyItem;
    }
    // console.log(emptyIndex,'emptyIndex')
    // handleIndexPre(emptyIndex)
    setDetailList(newArr);
  };
  // const handleIndexPre = (index: number) => () => {
  //   setOpenAccordions((prev) => {
  //     if (prev.includes(index)) {
  //       return prev;
  //     }
  //     return [...prev, index];
  //   });
  // };

  useEffect(() => {
    if (information) {
      updateDetailList('Account Information', information);
    }
  }, [information]);

  useEffect(() => {
    if (AccountBill) {
      updateDetailList('Account Bill', AccountBill);
    }
  }, [AccountBill]);

  useEffect(() => {
    if (AccountPayment) {
      updateDetailList('Account Payment', AccountPayment);
    }
  }, [AccountPayment]);

  useEffect(() => {
    if (billsImgList.length > 0) {
      updateDetailList('Account Bill', billsImgList, true);
    }
  }, [billsImgList]);

  useEffect(() => {
    if (usageList && usageList.monthly.length>0) {
      setActive('year')

    } else if (usageList && usageList.daily.length>0) {
      setActive('month')
    }
    else if (usageList && usageList.hourly_view.length>0) {
      setActive('day')
    }
    if (usageList) {
      updateDetailList('Usage', usageList);
    }
  }, [usageList]);

  useEffect(() => {
    if (usageList && active) {
      if (active === 'year') {
        let newRange = optionMonth[0]
        setSelectedRangeMonth(newRange);
        const updatedChartData = filterChartData(chartDataMonth, newRange);
        console.log(updatedChartData)
        setChartData(updatedChartData);
      }
      if (active === 'month') {
        let list = transformData(filteredDaily, month)
        setChartData(list);
        // const processedData = processData(usageList.monthly);
        // const sum = processedData.reduce((sum, item) => sum + item.value, 0);
        // setTotalUsage(`${sum.toFixed(2)} KWh`)
        // setChartData(processedData);
      }
      if (active === 'day') {
        let list = transformTo24HourFormat(filteredHoursData)
        setChartData(list);
      }
    }
  }, [active]);

  const transformTo24HourFormat = (data: any[]) => {
    const result = Array(24).fill(null).map((_, index) => {
      return {
        name: dayjs().startOf('day').hour(index).format('ha'),
        label: `${dayjs().startOf('day').hour(index).format('h:mm a')} - ${dayjs().startOf('day').hour(index + 1).format('h:mm a')}`,
        value: 0
      };
    });

    data.forEach((item: any) => {
      const time = item.end_time ? item.end_time : item.start_time;
      const hour = dayjs(time).hour();
      const formattedHour = dayjs().startOf('day').hour(hour).format('ha');

      const rawValue = item.value || 0;
      const numericValue = typeof rawValue === 'string' && rawValue.includes(' KWh')
        ? parseFloat(rawValue.replace(' KWh', ''))
        : parseFloat(rawValue);

      result[hour] = {
        name: formattedHour,
        label: `${dayjs().startOf('day').hour(hour).format('h:mm a')} - ${dayjs().startOf('day').hour(hour + 1).format('h:mm a')}`,
        value: isNaN(numericValue) ? 0 : numericValue
      };
    });

    return result;
  };

  const transformData = (filteredDaily: any[], selectedMonth: string) => {
    const monthStart = dayjs(selectedMonth).startOf('month');
    const monthEnd = dayjs(selectedMonth).endOf('month');
    const daysInMonth = monthEnd.date();

    const result = Array.from({ length: daysInMonth }, (_, index) => {
      const date = monthStart.add(index, 'day');
      const formattedTimeWeek = date.format('ddd DD');
      const formattedTime = date.format('MMM-DD');

      const item = filteredDaily.find((data: any) => {
        const dataDate = dayjs(data.start_time ? data.start_time : data.end_time).format('YYYY-MM-DD');
        return dataDate === date.format('YYYY-MM-DD');
      });

      return {
        name: formattedTimeWeek,
        value: item ? parseFloat(item.value.replace(' KWh', '')) : 0,
        label: formattedTime
      };
    });

    return result;
  };

  useEffect(() => {
    if (chartDataMonth.length > 0) {

      const updatedChartData = filterChartData(chartDataMonth, optionMonth[0]);
      setChartData(updatedChartData);
    }
  }, [chartDataMonth])

  const handleRangeChange = (newRange: string) => {
    setSelectedRangeMonth(newRange);

    const updatedChartData = filterChartData(chartDataMonth, newRange);
    setChartData(updatedChartData);
  };

  const handleMonthChange = (date: any) => {
    setMonth(dayjs(date));
    filterDailyData(dayjs(date), daily);
  };

  const handleDayChange = (date: any) => {
    setDaySelect(date);
    const hoursData = filterDataBySelectedDate(HoursData, dayjs(date).format('YYYY-MM-DD'))
    setFilteredHoursData(hoursData)
  };

  useEffect(() => {
    if (filteredDaily && active === 'month') {
      let list = transformData(filteredDaily, month)
      setChartData(list);
    }
  }, [filteredDaily]);

  useEffect(() => {
    if (filteredHoursData && active === 'day') {
      let list = transformTo24HourFormat(filteredHoursData)
      setChartData(list);
    }
  }, [filteredHoursData]);



  const downloadHandle = (file: string, event: React.MouseEvent<HTMLElement>) => {
    event?.stopPropagation()
    download_pdf(userToken, file).then((urlRes) => {
      if (urlRes.status == 1) {
        window.open(urlRes.url)
      }
    })
  }
  return (
    <div className="container max-w-7xl mx-auto px-4 md:px-8">
      <h2 className="font-bold text-2xl">The result of the enquiry is as follows</h2>
      <p className="font-light mt-6">The following data sources are the synchronized official website data of the user account</p>
      {/* {isFetching && (
          <div className="flex flex-col justify-center items-center min-h-[88px] space-y-4 mt-8">
            <CircularProgress />
            <span>Loading account data, please wait...</span>
          </div>
        )} */}
      <div className="mt-8 lg:mx-auto">
        {(DetailList ?? []).map((item, idx) => (
          <FUCollapse
            key={item.title + 'detail'}
            open={openAccordions.includes(idx)}
            toggleCollapse={handleAccordionToggle(idx)}
            showAll={showAll}
          >
            <div className="mt-4">
              <FUCollapse.Toggle
                openClass="[&>span]:rotate-180"
                className="inline-flex p-5 px-0 items-center justify-between w-full font-semibold text-left transition"
              >
                <div className="inline-flex items-center">
                  {item.error ? (
                    <FiAlertCircle className=' text-red-500 mr-4' size={30} />
                  ) : item.data.length === 0 ? (
                    <FaSpinner className=' animate-spin text-gray-500 mr-4' size={30} />
                  ) : (
                    <FiCheckCircle style={{ color: '#4caf50' }} size={30} className='mr-4' />
                  )}
                  <div>
                    {item.title}
                  </div>
                </div>
                <span className="material-symbols-rounded text-xl block duration-300 transition-transform">
                  <FaAngleDown />
                </span>
              </FUCollapse.Toggle>
              <FUCollapse.Menu className="w-full overflow-hidden transition-[height] duration-300">
                {(item.data ?? []).map((label: any, i: number) => (
                  <React.Fragment key={label.label}>
                    <p className="text-gray-700 dark:text-gray-300 pt-3 pb-5 px-0 flex justify-between md:px-5 gap-16">
                      <div className="">
                        {label.label}
                        {label.tooltip && (
                          <Tooltip
                            title={label.tooltip}
                            open={openTooltipIndex === `${idx} ${i}`}
                            onOpen={() => handleTooltipOpen(`${idx} ${i}`)}
                            onClose={handleTooltipClose}
                            onMouseEnter={() => handleTooltipOpen(`${idx} ${i}`)}
                            onMouseLeave={handleTooltipClose}
                            arrow
                            placement="top"
                            enterDelay={0}
                            leaveDelay={0}
                          >
                            <span className="ms-2 inline-block">
                              <i className="font-normal font-medium text-sm inline-block w-5 h-5 leading-5 text-center rounded-full bg-[#6288e980] text-white cursor-default">
                                ?
                              </i>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                      <span className='text-black-700 text-right'>{label.value}

                        {label.valueTooltip && (
                          <Tooltip
                            title={label.valueTooltip}
                            open={openTooltipIndex === `${idx} ${i}`}
                            onOpen={() => handleTooltipOpen(`${idx} ${i}`)}
                            onClose={handleTooltipClose}
                            onMouseEnter={() => handleTooltipOpen(`${idx} ${i}`)}
                            onMouseLeave={handleTooltipClose}
                            arrow
                            placement="top"
                            enterDelay={0}
                            leaveDelay={0}
                          >
                            <span className="ms-2 inline-block">
                              <i className="font-normal font-medium text-sm inline-block w-5 h-5 leading-5 text-center rounded-full bg-[#6288e980] text-white cursor-default">
                                ?
                              </i>
                            </span>
                          </Tooltip>
                        )}
                      </span>

                      {label.usage && <div className='flex items-center'>
                        <div className="flex border overflow-hidden bg-transparent shadow-md mr-4">
                          {label.usage.hourly_view && label.usage.hourly_view.length > 0 && <button
                            className={`flex-1 py-1 px-4 font-medium focus:outline-none transition-all ${active === 'day' ? 'bg-clip-text text-transparent bg-gradient-to-r from-[#1bd0f6] to-[#0da8ea] border-2 border-[#1bd0f6]' : 'text-black border-2 border-transparent'}`}
                            onClick={() => setActive('day')}
                          >
                            Day
                          </button>}

                          {label.usage.daily && label.usage.daily.length > 0 && <button
                            className={`flex-1 py-1 px-4 font-medium focus:outline-none transition-all ${active === 'month' ? 'bg-clip-text text-transparent bg-gradient-to-r from-[#1bd0f6] to-[#0da8ea] border-2 border-[#1bd0f6]' : 'text-black border-2 border-transparent'}`}
                            onClick={() => setActive('month')}
                          >
                            Month
                          </button>}

                          {label.usage.monthly && label.usage.monthly.length > 0 && <button
                            className={`flex-1 py-1 px-4 font-medium focus:outline-none transition-all ${active === 'year' ? 'bg-clip-text text-transparent bg-gradient-to-r from-[#1bd0f6] to-[#0da8ea] border-2 border-[#1bd0f6]' : 'text-black border-2 border-transparent'}`}
                            onClick={() => setActive('year')}
                          >
                            Year
                          </button>}
                        </div>

                        {label.usage.monthly && active === 'year' && <Select
                          value={selectedRangeMonth}
                          onChange={handleRangeChange}
                        >
                          {optionMonth.map((range, index) => (
                            <Option key={index} value={range}>
                              {range}
                            </Option>
                          ))}
                        </Select>}
                        {label.usage.monthly && active === 'month' &&
                          <DatePicker
                            disabledDate={(current) => !disabledDates.includes(current.format('YYYY-MM'))}
                            picker="month"
                            value={month}
                            onChange={handleMonthChange}
                            placeholder="select mounth"
                            format="MMM YYYY"
                          />}

                        {label.usage.hourly_view && active === 'day' &&
                          <DatePicker
                            format='dddd, MMM DD'
                            disabledDate={(current) => !availableDates.includes(current.format('YYYY-MM-DD'))}
                            placeholder="Select a date"
                            value={daySelect}
                            onChange={handleDayChange}
                          />}
                      </div>}

                    </p>
                    <div className='flex flex-col'>
                      {label.imgList && <div className="flex-wrap justify-between p-5 flex md:hidden">
                        {(showAll ? label.imgList : label.imgList.slice(0, 6)).map((item: any, index: number) => (
                          <div
                            key={index + 'usageItem'}
                            className="border-2 border-[#ccc] rounded-lg w-full sm:w-[48%] min-h-12 flex items-center justify-between my-2 cursor-pointer"
                          >

                            <div className="flex flex-col mx-2">
                              {/* Bill Date */}
                              <div className="text-[#666]">Bill Date: {" "}</div>
                              <div className="text-[#000]">{moment(item.date).format('MM/DD/YYYY')}</div>
                            </div>

                            <div className="flex flex-col">
                              {/* Amount */}
                              <div className="text-[#666]">Amount: {" "}</div>
                              <div className="text-[#000]">
                                {Number(item.total_amount_due) ? `$${Number(item.total_amount_due).toFixed(2)}` : item.total_amount_due}
                              </div>
                            </div>
                            <div
                              className={`mx-2 cursor-pointer ${item.file !== '' ? 'text-blue-600' : 'text-gray-400 cursor-not-allowed'}`}
                              onClick={(e) => {
                                if (item.file !== '') {
                                  downloadHandle(item.file, e);
                                }
                              }}
                            >
                              {'Download'}
                            </div>
                          </div>
                        ))}

                        {label.imgList.length > 6 && !showAll && (
                          <button onClick={handleToggleShow} className="text-blue-600 my-2 m-auto">
                            {'More'}
                          </button>
                        )}
                      </div>}
                      {label.imgList && <div className="flex-wrap justify-between p-5 hidden md:flex">
                        {label.imgList.map((item: any, index: number) => (
                          <div
                            key={index + 'usageItem'}
                            className="border-2 border-[#ccc] rounded-lg w-full sm:w-[48%] min-h-12 flex items-center justify-between my-2 cursor-pointer"
                          >
                            <div className="flex flex-row mx-2">
                              {/* Bill Date */}
                              <div className="text-[#666]">Bill Date: {" "}</div>
                              <div className="text-[#000]">{moment(item.date).format('MM/DD/YYYY')}</div>
                            </div>

                            <div className="flex flex-row">
                              {/* Amount */}
                              <div className="text-[#666]">Amount: {" "}</div>
                              <div className="text-[#000]">
                                {Number(item.total_amount_due) ? `$${Number(item.total_amount_due).toFixed(2)}` : item.total_amount_due}
                              </div>
                            </div>
                            <div
                              className={`mx-2 cursor-pointer ${item.file !== '' ? 'text-blue-600' : 'text-gray-400 cursor-not-allowed'}`}
                              onClick={(e) => {
                                if (item.file !== '') {
                                  downloadHandle(item.file, e);
                                }
                              }}
                            >
                              {'Download'}
                            </div>
                          </div>
                        ))}
                      </div>}
                    </div>
                    {label.usage && <Charts data={chartData}></Charts>}

                    {i !== item.data.length - 1 && <DashedDivider />}
                  </React.Fragment>
                ))}
                {item.error ?
                  <div className="w-full h-[200px] flex flex-col items-center justify-center">
                    <span>Oops~ No such data was found.</span>
                    <span>It's possible that there is no data of this type in the MyAccount of this account.</span>
                  </div> :
                  item.data.length === 0 ? (
                    <div className="w-full h-[200px] flex flex-col items-center justify-center">
                      <span>Loading data, please wait...</span>
                    </div>
                  ) : ''}
              </FUCollapse.Menu>
            </div>
            <Divider sx={{ borderColor: 'grey.700', borderWidth: '2px', borderTop: 'none' }} />
          </FUCollapse>
        ))}
      </div>
    </div>
  );
};
export default Detail;
